import React from 'react';
import { isEmpty } from 'lodash';

import HintFactory from '../../../../components/Hint/HintFactory';
import { HINT_ROOM_FACILITIES_NAME } from '../../constants';
import RoomFacilities from '../../components/TooltipContent/RoomFacilities';

interface RoomFacilitiesHintFactoryProps {
  items: {
    text: string;
    best?: boolean;
  }[];
  isMobile: boolean;
}
export const RoomFacilitiesHintFactory = ({
  items = [],
  isMobile,
}: RoomFacilitiesHintFactoryProps) =>
  !isEmpty(items) ? (
    <HintFactory
      events
      // это все только ради изменения ширины тултипа :(
      className={`react-hint react-hint--top react-hint--offset-top ${HINT_ROOM_FACILITIES_NAME}`}
      attribute={`data-${HINT_ROOM_FACILITIES_NAME}`}
      isMobile={isMobile}
      onRenderContent={() => (
        // TODO: унифицировать хинты
        <div className="react-hint__content">
          <RoomFacilities items={items} />
        </div>
      )}
    />
  ) : null;
